import { gql } from '@apollo/client'

export const findAllPVcusGQL = gql`
  query findAllPVcust {
    findAllPVcust {
      _id
      name
      facilityCapacity
      previousMethod
      revenueContractType
      contractPrice
      RECWeight
      pvOpt
    }
  }
`

export const UpdatePVcustGQL = gql`
  mutation updatePVcust($val: UpdatePVcustInput!) {
    updatePVcust(updatePVcustInput: $val) {
      _id
    }
  }
`

export const CreatePVcustGQL = gql`
  mutation createPVcust($val: CreatePVcustInput!) {
    createPVcust(createPVcustInput: $val) {
      _id
    }
  }
`

export const DeletePVcustGQL = gql`
  mutation deletePVcust($val: String!) {
    deletePVcust(_id: $val) {
      _id
    }
  }
`

export const findOnePVcusGQL = gql`
  query findOnePVcust($val: String!) {
    findOnePVcust(_id: $val) {
      _id
      name
      facilityCapacity
      previousMethod
      revenueContractType
      contractPrice
      RECWeight
      pvOpt
      patternList {
        patternId
        months
      }
    }
  }
`

export const findAllPVPatternNamesGQL = gql`
  query findAllPVAPINames {
    findAllPVAPINames {
      _id
      name
    }
  }
`

export const findPVPatternDataGQL = gql`
  query findAllPVAPI($val: FindAllPVAPIInput) {
    findAllPVAPI(findAllPVAPIInput: $val) {
      _id
      name
      pv_seq
      dt
      hr
      ndata
      generate_power
      meta_power
    }
  }
`
